import { useCallback } from 'react'
import IconButton from 'LuxKit/Button/IconButton'
import LineArrowDownIcon from 'LuxKit/Icons/line/LineArrowDownIcon'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'

interface MaldivesCharterDateRowFareToggleProps {
  expanded: boolean
  disabled: boolean
  onExpand: () => void
  onCollapse: () => void
  expandAriaLabel: string
  collapseAriaLabel: string
  unavailableAriaLabel: string
}

function MaldivesCharterDateRowFareToggle(props: MaldivesCharterDateRowFareToggleProps) {
  const {
    expanded,
    disabled,
    onExpand,
    onCollapse,
    expandAriaLabel,
    collapseAriaLabel,
    unavailableAriaLabel,
  } = props

  const handleClick = useCallback(() => {
    if (expanded) {
      onCollapse()
    } else {
      onExpand()
    }
  }, [expanded, onCollapse, onExpand])

  const ariaLabel = disabled ? unavailableAriaLabel : (expanded ? collapseAriaLabel : expandAriaLabel)

  return (
    <IconButton
      type="button"
      kind="secondary"
      variant="default"
      shape="square"
      size="small"
      isSelected={expanded}
      disabled={disabled}
      onClick={handleClick}
      aria-expanded={expanded}
      aria-label={ariaLabel}
    >
      {expanded ? <LineArrowDownIcon size="M" /> : <LineArrowRightIcon size="M" />}
    </IconButton>
  )
}

export default MaldivesCharterDateRowFareToggle
